import axios from 'axios';
import {cnxAPI, notifica, show_ldr, getUser} from '../requests/utils';

var a = null, b = null, c = null;

//Función para obtener las notificaciones
function getAlertas(_callback){
    var usr = getUser(),
        json = {idCandidato: usr.idCandidato};
    show_ldr(true);
    axios({
        method: 'post',
        url: cnxAPI + 'Candidato/GetAlertaCandidatos',
        headers: {'Content-Type': 'application/json; charset=utf-8', 'X-Requested-With':'XMLHttpRequest'},
        data: json
    }).then(function (response) {
        show_ldr(false);
        if(response.status !== 200){
           notifica('warning', response.data.message, 'Alerta!');
        }else{
            a = response.data;
        }
    }).catch(function (error) {
        notifica('danger', error, 'Error');
    }).then(() => _callback(a));
}

//Función para obtener las notificaciones
function getAlertas2(_callback){

    var idAlerta =document.getElementById('lbl_Modal').innerText;
    var usr = getUser(),
        json = {idCandidato: usr.idCandidato,idAlerta};
    show_ldr(true);
    axios({
        method: 'post',
        url: cnxAPI + 'Candidato/GetAlertaCandidatos',
        headers: {'Content-Type': 'application/json; charset=utf-8', 'X-Requested-With':'XMLHttpRequest'},
        data: json
    }).then(function (response) {
        show_ldr(false);
        if(response.status !== 200){
           notifica('warning', response.data.message, 'Alerta!');
        }else{
            a = response.data;
        }
    }).catch(function (error) {
        notifica('danger', error, 'Error');
    }).then(() => _callback(a));
}

//Función para obtener una alerta
function saveAlerta(_callback){
    
    var json = getAlertForm();

    show_ldr(true);
    axios({
        method: 'post',
        url: cnxAPI + 'Candidato/' + json.endpoint,
        headers: {'Content-Type': 'application/json; charset=utf-8', 'X-Requested-With':'XMLHttpRequest'},
        data: json.datos
    }).then(function (response) {
        show_ldr(false);
        if(response.status !== 200){
            notifica('warning', response.data.message, 'Alerta!');
        }else{
            b = response.data;
        }
    }).catch(function (error) {
        notifica('danger', error, 'Error');
    }).then(() => _callback(b));
}

//función para obtener los datos
function getAlertForm(){
    var dv = document.getElementById('dv_Alerts'),
        inps = dv.querySelectorAll('.frm_Alrts'),
        js = '{', usr = getUser(), ep = 'UpdateAlertaCandidatos';
    inps.forEach(function(i){
        var nm = (i.getAttribute('name') !== 'idAlertaCandidato' ? i.getAttribute('name') : 'idAlerta'),
            vl = (nm !== 'idEstatus' ? i.value : (i.checked ? 'true' : 'false'));
        


        if(nm === 'idAlerta' && vl === ''){
            ep = 'InsertAlertaCandidatos';
        }else if(nm === 'salarioMinimo'){
            var num = vl.replace('.','') === "" ? 0 : vl.replace('.','') ;
            js += '"' + nm + '":' + num + ',';
        }else{
            js += '"' + nm + '":"' + vl + '",';
        }
    });
    js += '"idCandidato" : ' + usr.idCandidato + '}';
    return {endpoint: ep, datos: JSON.parse(js)}
}

//Función para eliminar una alerta
function eliminaAlerta(_callback){
    var lbl = document.getElementById('lbl_util'),
        usr = getUser(),
        json = {idCandidato: usr.idCandidato, idAlerta: parseInt(lbl.innerText, 10)};

    show_ldr(true);
    axios({
        method: 'post',
        url: cnxAPI + 'Candidato/DeleteAlertaCandidatos',
        headers: {'Content-Type': 'application/json; charset=utf-8', 'X-Requested-With':'XMLHttpRequest'},
        data: json
    }).then(function (response) {
        show_ldr(false);
        if(response.status !== 200){
            notifica('warning', response.data.message, 'Alerta!');
        }else{
            c = response.data;
        }
    }).catch(function (error) {
        notifica('danger', error, 'Error');
    }).then(() => _callback(c));
}

export {getAlertas,getAlertas2, saveAlerta, eliminaAlerta}